module.exports = __webpack_public_path__ + "images/lntegral_icon_fail.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/lntegral_icon_fail.png
// module id = 826
// module chunks = 125